export default () => {
  (function (mobileNavigation) {
    "use strict";

    const dom = {};
    const overlay = new window.Overlay()

    const cacheDom = () => {
      dom.trigger = document.querySelector(".js-open-menuDrawer");
      dom.triggerClose = document.querySelector(".js-close-menuDrawer");
      dom.triggerExpand = document.querySelectorAll(".js-expand");
      dom.triggerCollapse = document.querySelectorAll(".js-collapse");
    };

    const bindUIActions = () => {
      dom.trigger.addEventListener("click", toggleNavigation);
      dom.triggerClose.addEventListener("click", toggleNavigation);

      dom.triggerExpand.forEach((element) => {
        element.addEventListener("click", () => {
          element.nextElementSibling.classList.add("is--active");
        });
      });

      dom.triggerCollapse.forEach((element) => {
        element.addEventListener("click", () => {
          element.parentNode.classList.remove("is--active");
        });
      });
    };

    const toggleNavigation = () => {
      const mNav = document.querySelector(".js-m-nav");

      if (mNav.getAttribute("aria-hidden") == "true") {
        mNav.setAttribute("aria-hidden", "false");
        document.body.classList.add("m__nav--open","overflow__hide");
        overlay.show();
      } else {
        mNav.setAttribute("aria-hidden", "true");
        document.body.classList.remove("m__nav--open","overflow__hide");
        overlay.hide();

        setTimeout(() => {
          mNav.querySelectorAll('.is--active').forEach((element) => {
            element.classList.remove('is--active')
          })
        },150)
      }
    };

    overlay.on('cancel',toggleNavigation);

    const init = () => {
      cacheDom();
      bindUIActions();
    };

    mobileNavigation.init = init;
  })((window.mobileNavigation = window.mobileNavigation || {}));
};
